<template>
  <div class="d-flex">
    <div  class="INFO">
      <vk-icon
          v-tooltip="{
            content:infoContent,
          }"
          name="exclamation-circle-outlined"
          size="22"
      />
    </div>
    <div class="UNDERLINE">How to add multiple photos</div>
  </div>
</template>

<script>
export default {
  name: 'photo-info',
  data () {
    return {
      focused: false,
      infoContent: `To add multiple photos on Desktop, click on the Add Photos button to open your file directory. While browsing your file directory, click on each photo you would like to add while holding down the Shift key. Then, click the Open button to add all of the selected photos.<br><br>
      For IOS and Android, press the Add Photos button to open your gallery. Press each photo you would like to add, then press the Add button.`,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .INFO {
    color: #1890FF;
    margin-right: 8px;
  }

  .UNDERLINE {
    text-decoration: underline;
  }
</style>
